import { gql } from 'apollo-boost';

export const getPageStatsWithChartQuery = gql`
  query PageStatsWithChart($period: ReportPeriodType) {
    PageStatsWithChart(input: { period: $period }) {
      viewCount
      clickCount
      pageStats {
        label
        value
      }
      linksStats {
        label
        value
      }
    }
  }
`;

export const getPageLinkStatsQuery = gql`
  query PageLinkStats($period: ReportPeriodType, $type: LinkType!) {
    PageLinkStats(input: { period: $period, type: $type }) {
      clickCount
      internalClickCount
      externalClickCount
      topItems {
        # id
        title
        url
        createDate
        clickCount
      }
    }
  }
`;

export const getUsersWithChartQuery = gql`
  query UsersWithChart($period: ReportPeriodType) {
    UsersWithChart(input: { period: $period }) {
      basicUsersStats {
        label
        value
      }
      proUsersStats {
        label
        value
      }
    }
  }
`;

export const getLinksWithChartQuery = gql`
  query LinksWithChart($period: ReportPeriodType) {
    LinksWithChart(input: { period: $period }) {
      label
      value
    }
  }
`;

export const getReportSummaryQuery = gql`
  query {
    ReportSummary {
      userCount
      userCountChange
      proUserCount
      proUserCountChange
      income
      todayIncome
      todayIncomeChange
    }
  }
`;

export const getLinkSummaryQuery = gql`
  query {
    LinksSummary {
      count
      countChange
      activeCount
      clickCount
      clickCountChange
      avgClickCount
      avgUserLinks
      topTen {
        id
        url
        clickCount
      }
    }
  }
`;

export const getGallerySummaryQuery = gql`
  query {
    GallerySummary {
      count
      countChange
      activeCount
      clickCount
      clickCountChange
      avgClickCount
      avgUserLinks
      categoryCount
      avgUserCategories
      avgCategoryPosts
      topTen {
        id
        url
        clickCount
      }
    }
  }
`;

export const getShopSummaryQuery = gql`
  query {
    ShopSummary {
      count
      countChange
      activeCount
      orderCount
      orderCountChange
      avgUserOrders
      avgProductOrders
      avgUserLinks
      categoryCount
      avgUserCategories
      avgCategoryPosts
      topTen {
        id
        url
        clickCount
      }
    }
  }
`;

export const getPageVisitorsDetail = gql`
  query {
    PageVisitorsDetail {
      countries {
        code
        title
        value
      }
      browsers {
        code
        title
        value
      }
      os {
        code
        title
        value
      }
      devices {
        code
        title
        value
      }
      refers {
        code
        title
        value
      }
      lastActivities {
        countryCode
        countyName
        refer
        device
        os
        browser
        createDate
      }
    }
  }
`;
